import { Upload } from 'lucide-react';
import { motion, AnimatePresence } from 'motion/react';

/**
 * Full-page drag overlay — emerald glass-panel, heartbeat icon.
 *
 * Mounted at the top of <App> so it shows on any route (Capsules / Send /
 * Settings) when the Tauri window detects a drag-enter, AND inside
 * SendCapsule when the browser's window-level drag listener fires.
 *
 * `show` is a boolean — caller decides when it's visible. The component
 * itself is animated via AnimatePresence so it fades cleanly on toggle.
 */
export function DragOverlay({
  show,
  workspace,
  label = 'Drop to start a capsule',
  hint,
}: {
  show: boolean;
  workspace?: string;
  label?: string;
  hint?: string;
}) {
  const computedHint =
    hint ?? (workspace
      ? <>Files become sources in workspace <code className="font-mono" style={{ color: '#34D399' }}>{workspace}</code></>
      : 'Text and markdown files only — PDFs / DOCX need the CLI');

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 pointer-events-none flex items-center justify-center z-50"
          style={{
            background: 'rgba(5, 5, 5, 0.7)',
            backdropFilter: 'blur(4px)',
          }}
        >
          <div
            className="glass-panel-strong rounded-2xl p-12 text-center heartbeat"
            style={{ borderColor: '#10B981', borderWidth: 2 }}
          >
            <Upload size={48} style={{ color: '#10B981', margin: '0 auto 12px' }} />
            <div className="display text-3xl mb-2">{label}</div>
            <div className="text-sm" style={{ color: 'rgba(240,253,244,0.6)' }}>{computedHint}</div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
